import { render, staticRenderFns } from "./json_schema_editor_value.vue?vue&type=template&id=8f1230ba"
import script from "./json_schema_editor_value.vue?vue&type=script&lang=js"
export * from "./json_schema_editor_value.vue?vue&type=script&lang=js"
import style0 from "./json_schema_editor_value.vue?vue&type=style&index=0&id=8f1230ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports